import React from "react";
import AuthButton from "../../Buttons/AuthButton";
import MobileMenu from "../containers/MobileMenu/"
import { Link } from "react-router-dom";
import "./Header.scss";
import * as ROUTES from '../../../routes';

function Header(props) {
  return (
    <header>
      <div className="header">
        <div className="header-wrapper">
          <Link className='logolink' to='/'>
            <img src="/img/logo/w.svg" alt="logo" />
          </Link>

          <div className="header-buttons">
            <Link to="ingresa">
              <AuthButton variant="primary">Inicia Sesión</AuthButton>
            </Link>
            <Link to={ROUTES.SIGNUP}>
              <AuthButton variant="secondary">Regístrate</AuthButton>
            </Link>
          </div>
        </div>
      </div>
      <div className="mobile-header">
        <MobileMenu />
      </div>
    </header>
  );
}

export default Header;
